var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_7085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6786 13.2192C6.84719 14.5054 7.47875 15.686 8.45506 16.5401C9.43136 17.3942 10.6855 17.8632 11.9826 17.8594C13.2798 17.8555 14.5311 17.379 15.5023 16.519C16.4735 15.6591 17.098 14.4747 17.2589 13.1876C17.4197 11.9004 17.106 10.5987 16.3764 9.5262C15.6468 8.45367 14.5513 7.68382 13.295 7.36076C12.0387 7.0377 10.7077 7.18357 9.55119 7.77107C8.39468 8.35857 7.49194 9.34743 7.01194 10.5525",
    stroke: "#3451D7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68003 8.94922V10.5492H8.28003",
    stroke: "#3451D7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_7085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.631b85e72eee90abb6d0c2066cbb2e9e.svg";
export { ForwardRef as ReactComponent };